var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.4,
    height: 26.952,
    viewBox: "0 0 27.4 26.952",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Line-Black",
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_972",
    "data-name": "Path 972",
    d: "M18.39,27.133l1.938,1.939a.914.914,0,1,0,1.291-1.292l-1.86-1.86a5.469,5.469,0,1,0-1.369,1.214Zm-2.9-8.306a3.653,3.653,0,1,1-3.653,3.653A3.655,3.655,0,0,1,15.494,18.827Z",
    transform: "translate(-0.781 -1.387)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_973",
    "data-name": "Path 973",
    d: "M2.827,6.327l10.392,6.68a2.74,2.74,0,0,0,2.963,0l10.392-6.68v9.287a.914.914,0,0,1-.913.913H21.991a.913.913,0,1,0,0,1.827H25.66a2.741,2.741,0,0,0,2.74-2.74V3.74A2.741,2.741,0,0,0,25.66,1H3.74A2.741,2.741,0,0,0,1,3.74V15.613a2.741,2.741,0,0,0,2.74,2.74H7.328a.913.913,0,1,0,0-1.827H3.74a.914.914,0,0,1-.913-.913ZM26.574,4.155V3.74a.914.914,0,0,0-.913-.913H3.74a.914.914,0,0,0-.913.913v.415l11.379,7.316a.917.917,0,0,0,.988,0Z",
    transform: "translate(0 0)",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail1);
export default __webpack_public_path__ + "static/media/email-1.8b7a23bdc2c02c63900bdbd5d2c320c0.svg";
export { ForwardRef as ReactComponent };